import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestLoa } from "../../entity/EntityRequestLoa";

export class DtoRequestLoasGetRes extends EntityRequestLoa {
  public items: EntityRequestLoa[]  = [];
}
